import { Box, Button, Group, Select, TextInput, Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { TblAttributeValueCommand } from "../../model/TblAttributeValueCommand";
import { _validateValue } from "../../validate/TblAttributeValueCommandValidator";
const FormValueAdd = function ({
  idAttr,
  data,
  list,
  set,
}: {
  idAttr: number;
  data: TblAttributeValueCommand;
  list: TblAttributeValueCommand[];
  index: number;
  set: React.Dispatch<React.SetStateAction<TblAttributeValueCommand[]>>;
}) {
  const entity: TblAttributeValueCommand = {
    id: 0,
    attributeId: null,
    value: null,
    description: null,
    orderNumber: null,
    status: "A",
    imageUrl: null,
    creationDate: null,
    createdBy: null,
    lastUpdateDate: null,
    lastUpdatedBy: null,
    lastUpdatedLogin: null,
  };
  const form = useForm<TblAttributeValueCommand>({
    initialValues: {
      ...entity,
    },

    validate: _validateValue,
  });

  const [visible] = useDisclosure(false);
  const [isCreate, setIsCreate] = useState<boolean>(false);
  useEffect(() => {
    data.attributeId = idAttr;
    // Nếu là tạo mới và status null thì set mặc định là "A"
    if (
      (data.id === undefined || data.id === null || data.id < 1) &&
      !data.status
    ) {
      data.status = "A";
      setIsCreate(true);
    }
    form.setValues(data);
    form.resetDirty(data);
    if (data.id === undefined || data.id === null || data.id < 1)
      setIsCreate(true);
  }, [data, idAttr]);

  const apiCreate = (d: TblAttributeValueCommand) => {
    // console.log(list);
    if (d.value === null || d.value === undefined || d.value.length < 1) {
      NotificationExtension.Fails("Giá trị chưa nhập !");
      return;
    }
    let check = list.findIndex((x) => x.value === d.value);
    if (check > -1) {
      NotificationExtension.Fails("Giá trị đã tồn tại !");
      return;
    }

    // Tạo mảng mới thay vì mutate mảng cũ
    const newList = [
      ...list,
      {
        ...d,
        apikey: String(d.apikey).toLowerCase().replace(/\s+/g, "-"),
      },
    ]
      .filter(
        (x) => x.value !== null && x.value !== undefined && x.value.length > 0
      )
      .sort((a, b) => {
        const orderA = a.orderNumber || 0;
        const orderB = b.orderNumber || 0;
        return orderB - orderA;
      });

    set(newList);
    NotificationExtension.Success("Thêm thành công !");
  };
  const apiEdit = (d: TblAttributeValueCommand) => {
    if (d.value === null || d.value === undefined || d.value.length < 1) {
      NotificationExtension.Fails("Giá trị chưa nhập !");
      return;
    }
    let check = list.findIndex((x) => x.id === d.id);
    if (check < 0) {
      NotificationExtension.Fails("Giá trị không tồn tại !");
      return;
    }

    // Tạo mảng mới thay vì mutate mảng cũ
    const newList = list
      .filter(
        (x) =>
          x.value !== null &&
          x.value !== undefined &&
          x.value.length > 0 &&
          x.id !== d.id
      )
      .concat([
        { ...d, apikey: String(d.apikey).toLowerCase().replace(/\s+/g, "-") },
      ])
      .sort((a, b) => {
        const orderA = a.orderNumber || 0;
        const orderB = b.orderNumber || 0;
        return orderB - orderA;
      });

    set(newList);
    NotificationExtension.Success("Thao tác thành công !");
  };

  const apiDelete = (d: TblAttributeValueCommand) => {
    if (isCreate) {
      // Cho phép xóa kể cả khi value rỗng
      let check = list.findIndex((x) => x === d || x.value === d.value);
      if (check < 0) {
        NotificationExtension.Fails("Giá trị không tồn tại !");
        return;
      }
      const newList = list.filter((x, idx) => idx !== check);
      set(newList);
      NotificationExtension.Success("Xóa thành công !");
    } else {
      if (d.id === null || d.id === undefined || d.id < 1) {
        NotificationExtension.Fails("Giá trị không có !");
        return;
      }
      let check = list.findIndex((x) => x.id === d.id);
      if (check < 0) {
        NotificationExtension.Fails("Giá trị không tồn tại !");
        return;
      }
      const newList = list.filter((x) => x.id !== d.id);
      set(newList);
      NotificationExtension.Success("Xóa thành công !");
    }
  };
  const formCreate = (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={600}
        mx="auto"
        onSubmit={form.onSubmit((e: TblAttributeValueCommand) => {
          console.log(e);
        })}
      >
        <Group justify="flex-end">
          <TextInput
            mt={"xs"}
            label="ID: "
            disabled={true}
            withAsterisk
            {...form.getInputProps("id")}
          />
          <TextInput
            mt={"xs"}
            label="Giá trị: "
            placeholder={"Nhập giá trị..."}
            value={form.getValues().value}
            withAsterisk
            {...form.getInputProps("value")}
            onChange={(e) => {
              const newValue = e.currentTarget.value;
              // Chuyển đổi có dấu thành không dấu và tạo slug
              const slugValue = newValue
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .replace(/[^a-z0-9\s-]/g, "")
                .replace(/\s+/g, "-")
                .replace(/-+/g, "-")
                .replace(/^-+|-+$/g, "");
              form.setValues((prev) => ({
                ...prev,
                value: newValue,
                apikey: slugValue,
              }));
            }}
          />
          <TextInput
            mt={"xs"}
            label="ApiKey: "
            placeholder={"Nhập ApiKey..."}
            withAsterisk
            {...form.getInputProps("apikey")}
            onChange={(e) => {
              const newValue = e.currentTarget.value;
              // Chuyển thành không dấu và slug
              const slugValue = newValue
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .replace(/[^a-z0-9\s-]/g, "")
                .replace(/\s+/g, "-")
                .replace(/-+/g, "-")
                .trim();
              form.setValues((prev) => ({
                ...prev,
                apikey: slugValue,
              }));
            }}
          />
          <TextInput
            mt={"xs"}
            label="Ảnh icon: "
            placeholder={"Nhập đường dẫn ảnh..."}
            {...form.getInputProps("imageUrl")}
          />
          <Select
            mt={"xs"}
            label="Trạng thái: "
            placeholder="Chọn trạng thái"
            data={[
              { value: "A", label: "Hoạt động" },
              { value: "Y", label: "Không hoạt động" },
            ]}
            {...form.getInputProps("status")}
          />
          <Textarea
            mt={"xs"}
            label="Mô tả :"
            placeholder={"Nhập mô tả..."}
            autosize
            minRows={1}
            {...form.getInputProps("description")}
          />
          <TextInput
            mt={"xs"}
            type="number"
            label="Thứ tự xuất hiện (cao xếp trước): "
            placeholder={"Nhập thứ tự..."}
            {...form.getInputProps("orderNumber")}
          />
          <Button
            mt={"xl"}
            type="button"
            color="#3598dc"
            loading={visible}
            onClick={(e) => {
              if (isCreate) apiCreate(form.getValues());
              else apiEdit(form.getValues());
            }}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            {isCreate ? "Lưu" : "Sửa"}
          </Button>
          <Button
            mt={"xl"}
            variant="outline"
            color="black"
            type="button"
            loading={visible}
            onClick={() => {
              apiDelete(form.values);
            }}
            leftSection={!visible ? <IconX size={18} /> : undefined}
          >
            Xóa
          </Button>
        </Group>
      </Box>
    </>
  );

  return <>{formCreate}</>;
};

export default FormValueAdd;
